<template>
  <div
    class="card-placeholder"
    @dragover="dragOver($event)"
    @drop="active ? drop($event) : null"
  >
    <span class="card-placeholder__length" v-if="cardLength">{{
      cardLength
    }}</span>
    <slot></slot>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    active: {
      type: Boolean,
      default: false
    },
    position: {
      type: Number,
      default: null
    },
    nextNumber: {
      type: Number,
      default: null
    },
    cardLength: {
      type: Number,
      default: null
    },
    type: {
      validator: value => {
        return ['tableCard', 'putAway'].includes(value);
      }
    }
  },
  methods: {
    dragOver(event) {
      event.preventDefault();
    },
    drop(event) {
      const card = JSON.parse(event.dataTransfer.getData('card'));
      const from = event.dataTransfer.getData('from');
      const position = Number(event.dataTransfer.getData('position'));

      if (from === 'hand' && this.type === 'putAway') {
        this.setPutAway(card);
      } else {
        this.setTableCard(from, card, position);
      }
    },
    setTableCard(from, card, position) {
      const nextNumber = this.nextNumber;
      const allowCard = card.number === nextNumber || card.joker;
      if (allowCard) {
        if (from === 'hand') {
          this.$store.dispatch('setTableCardFromHand', {
            card,
            toPosition: this.position
          });
        } else if (from === 'stock') {
          this.$store.dispatch('setTableCardFromStock', {
            card,
            toPosition: this.position
          });
        } else {
          this.$store.dispatch('setTableCardFromPutAway', {
            card,
            toPosition: this.position,
            fromPosition: position
          });
        }
      }
    },
    setPutAway(card) {
      this.$store.dispatch('setPutAway', {
        card,
        toPosition: this.position
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.card-placeholder {
  position: relative;
  width: 56px;
  height: 80px;
  margin: 0 15px;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 4px 0px,
    rgba(0, 0, 0, 0.05) 0px 1px 3px 0px;

  &__length {
    position: absolute;
    bottom: 2px;
    left: 2px;
    padding: 1px 3px;
    background-color: #000;
    color: #fff;
    z-index: 1;
    font-size: 8px;
    font-weight: 600;
  }
}
</style>
